import * as React from 'react';
import { ComponentProps } from 'ui';
import { LeftPanel } from 'app/components/case-header-panel/panels/left-panel';
import styles from './compact-tile-header.scss';

export interface CompactTileHeaderProps extends ComponentProps {
  children: any;
  headerTitle?:string;
}

export const CompactTileHeader: React.FC<React.PropsWithChildren<CompactTileHeaderProps>> = (props: CompactTileHeaderProps) => {

  const {
    componentId,
    className,
    children,
    headerTitle
  } = props;

  return (
    <div id={componentId} className={`${className} ${styles.tileHeader} compact row`}>
      {headerTitle && <div className={styles.key}>
        {headerTitle}
      </div> }
      <LeftPanel>{children}</LeftPanel>
    </div>
  );
};
